'use strict';
//////////////  BEGIN DEV TRACKING ------->
/**
 * the following chunk of code is only for testing the tracking outside of the AEM environment, which inserts its own tracking libraries.
 */
if (window.location.hostname === 'localhost' || window.location.hostname === '10.0.2.2' || window.location.hostname === 'selector.hmibrand.com') {
    console.log('on development environment: ', window.location.hostname, 'use development tracking');
    (function(i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function() {
            (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
            m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m)
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

    ga('create', 'UA-73894066-1', 'auto');
    ga('send', 'pageview');

    var _gaq = _gaq || [];
    _gaq.push(['_setAccount', 'UA-73894066-1']);
    _gaq.push(['_setDomainName', '.hmibrands.com']);

    _gaq.push(['_trackPageview']);

    (function() {
        var ga = document.createElement('script');
        ga.type = 'text/javascript';
        ga.async = true;
        ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(ga, s);
    })();

    window.ga = ga;
    window._gaq = _gaq;
}
//////////// < ----- END DEV TRACKING


var pageQueue = [];
var eventQueue = [];

if (window && window.ga) {
    window.ga(function() {
        console.log('analytics.js: ga object ready');

        pageQueue.forEach(function(pageEvent) {
            console.log('track queued page', pageEvent);
            setPage(pageEvent.page, pageEvent.title, true);
        });
        eventQueue.forEach(function(event) {
            console.log('track queued event', event);
            trackEvent(event, true);
        });

        pageQueue = [];
        eventQueue = [];
    });
} else {
    console.warn('analytics.js error: no ga object detected');
}

function stripHTML(str) {
    str = str.replace(/<(?:.|\s)*?>/g, '');
    str = str.replace(/&nbsp;/g, ' ');
    return str;
}

function trackShare(shareMethods) {
    trackEvent({
        category: 'Chair Selector',
        action: 'share',
        label: shareMethods
    });
}

function trackEvent(params, queuedTrack) {
    var ga = window.ga; //newer analytics.js
    var _gaq = window._gaq; //older ga.js

    //expects category, action, and label
    params.category = stripHTML(params.category);
    params.action = stripHTML(params.action);
    params.label = stripHTML(params.label);

    params.nonInteraction = params.nonInteraction || false;

    //old school ga.js tracking
    if (queuedTrack !== true) {
        if (typeof _gaq !== 'undefined') {
            console.log('nonInteraction', params.nonInteraction);
            _gaq.push(['_trackEvent', params.category, params.action, params.label, -99, params.nonInteraction]);
            // _gaq.push([‘_trackEvent’, ’Category’, ’Action’, ’Opt Label’, Opt Value, ’Opt non-interaction’])
        } else {
            console.warn('no _gaq array found for ga.js tracking');
        }
    }

    //new school analytics.js
    if (typeof ga === 'undefined' || typeof ga.getAll === 'undefined') {
        console.warn('tracking event error: ga (analytics.js) is undefiend or not loaded yet, adding event to queue', params);
        eventQueue.push(params);
    } else {
        if (queuedTrack) {
            console.log('queued tracking event called', params);
        }
        var trackers = ga.getAll();

        trackers.forEach(function(tracker) {
            console.log('sending event to tracker: ', tracker.get('name'), params);
            tracker.send('event', params.category, params.action, params.label, {
                nonInteraction: params.nonInteraction
            });
        });
    }
}


function setPage(page, title, queuedTrack) {
    var ga = window.ga; //newer analytics.js
    var _gaq = window._gaq; //older ga.js

    page = stripHTML(page);
    title = stripHTML(title);

    var fullpagepath;
    if (queuedTrack !== true) {
        //_gaq does not need load any libraries, and thus is not part of our little queue system. Only track non-queue calls as they were already tracked.
        if (typeof _gaq !== 'undefined') {
            console.log('set gaq title to:', title,'and page to:',page);
            _gaq.push(['_set', 'title', title]);
            fullpagepath = '/chair-selector' + page;
            _gaq.push(['_set', 'page', fullpagepath]);
            _gaq.push(['_trackPageview']);
            // _gaq.push(['_trackPageview', page]);
        } else {
            console.warn('no _gaq array found for ga.js tracking');
        }
    }

    if (typeof ga === 'undefined' || typeof ga.getAll === 'undefined') {
        console.warn('tracking page error: ga (analytics.js) is undefiend or not loaded yet', page, title, 'added to queue.');
        pageQueue.push({
            page: page,
            title: title
        });
    } else {
        if (queuedTrack) {
            console.log('queued tracking page called', page, title);
        }
        var trackers = ga.getAll();
        fullpagepath = '/chair-selector' + page;
        trackers.forEach(function(tracker) {
            console.log('sending page', page, 'to tracker: ', tracker.get('name'));
            tracker.set({
                page: fullpagepath,
                title: title
            });
            tracker.send('pageview');
        });
    }
}

module.exports = {
    setPage: setPage,
    trackEvent: trackEvent,
    trackShare: trackShare
};
